import { GraduationCap, Globe, Banknote, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const segments = [
  {
    id: 'future',
    icon: <GraduationCap className="w-10 h-10 text-gold" />,
    titleKey: 'info_future_students',
    descKey: 'info_future_students_desc',
    link: '/admissions/future'
  },
  {
    id: 'intl',
    icon: <Globe className="w-10 h-10 text-gold" />,
    titleKey: 'info_international_students',
    descKey: 'info_international_students_desc',
    link: '/admissions/international'
  },
  {
    id: 'aid',
    icon: <Banknote className="w-10 h-10 text-gold" />,
    titleKey: 'scholarships_hero_title',
    descKey: 'scholarships_hero_subtitle_short',
    link: '/admissions/scholarships'
  }
];

export default function AdmissionsSegments() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 animate-in fade-in slide-in-from-bottom-8 duration-700">
      {segments.map((seg) => (
        <Link 
          key={seg.id} 
          to={seg.link}
          className="bg-white p-8 border-b-4 border-navy shadow-sm hover:shadow-2xl transition-all group flex flex-col items-start h-full rounded-sm"
        >
          <div className="mb-6 group-hover:scale-110 transition-transform">{seg.icon}</div>
          <h3 className="text-xl font-black text-navy mb-4 uppercase tracking-tight leading-tight">
            {t(seg.id === 'future' ? 'info_future_students' : (seg.id === 'intl' ? 'info_international_students' : 'scholarships_hero_title'))}
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed mb-8 font-medium">
            {t(seg.id === 'future' ? 'info_future_students_desc' : (seg.id === 'intl' ? 'info_intl_desc' : 'scholarships_hero_subtitle_short'))}
          </p>
          <div className="mt-auto text-xs font-black uppercase tracking-[0.2em] text-navy group-hover:text-gold flex items-center gap-2 transition-colors">
            {t('common_learn_more', 'En savoir plus')} <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </div>
        </Link>
      ))}
    </div>
  );
}
